import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Checkbox = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15.17 22.42a1 1 0 01-.71-.29L7.24 14.9a1 1 0 111.41-1.41l6.4 6.4 13-17.49a1 1 0 111.6 1.2L16 22a1 1 0 01-.73.4zM29.89 29V12.39a1 1 0 00-2 0V28h-24V4h17.06a1 1 0 000-2H2.89a1 1 0 00-1 1v26a1 1 0 001 1h26a1 1 0 001-1z" })), '0 0 32 32', 'Checkbox');
//# sourceMappingURL=Checkbox.js.map